var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1562 12.3125H17.8438C12.4158 12.3125 8 16.7283 8 22.1562V37.3599C8 41.691 10.8436 45.4634 14.9642 46.6708L19.7184 51.4253C19.9824 51.689 20.3398 51.8373 20.713 51.8373C21.0858 51.8373 21.4436 51.689 21.7073 51.4253L26.0685 47.0637H46.1562C51.5842 47.0637 56 42.6479 56 37.22V22.1562C56 16.7283 51.5842 12.3125 46.1562 12.3125ZM53.1875 37.22C53.1875 41.097 50.0333 44.2512 46.1562 44.2512H25.4862C25.1134 44.2512 24.7556 44.3995 24.4919 44.6632L20.713 48.4421L16.6884 44.4175C16.5078 44.2369 16.2815 44.1088 16.0336 44.0472C12.9596 43.2822 10.8125 40.5323 10.8125 37.3599V22.1562C10.8125 18.2792 13.9667 15.125 17.8438 15.125H46.1562C50.0333 15.125 53.1875 18.2792 53.1875 22.1562V37.22Z",
    fill: "#1F3232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.929 25.7964H23.071C22.2943 25.7964 21.6648 26.4263 21.6648 27.2026C21.6648 27.9794 22.2943 28.6089 23.071 28.6089H40.929C41.7057 28.6089 42.3352 27.9794 42.3352 27.2026C42.3352 26.4263 41.7057 25.7964 40.929 25.7964Z",
    fill: "#528586"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.929 30.7676H23.071C22.2943 30.7676 21.6648 31.3971 21.6648 32.1738C21.6648 32.9506 22.2943 33.5801 23.071 33.5801H40.929C41.7057 33.5801 42.3352 32.9506 42.3352 32.1738C42.3352 31.3971 41.7057 30.7676 40.929 30.7676Z",
    fill: "#528586"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.eaa09a9d8e325c08367c951f3345e752.svg";
export { ForwardRef as ReactComponent };